import { render, staticRenderFns } from "./examplesTab.vue?vue&type=template&id=0cb56c3e&scoped=true&"
import script from "./examplesTab.vue?vue&type=script&lang=js&"
export * from "./examplesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb56c3e",
  null
  
)

export default component.exports